import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  title: "Al-Tijarat al-Raabehah — Chicago — Empowering Business Success",
  description:
    "Al-Tijarat al-Raabehah Chicago — empowering Mumineen entrepreneurs through business resources, community initiatives, and small-business support.",
  // Keep in step with SITE.defaultImage in api/og/index.js and the og:image
  // defaults in public/index.html. logo.jpg is the same picture as logo.png at
  // a fifth of the bytes.
  image: "https://tr.chicagojamaat.org/logo.jpg",
  siteName: "Al-Tijarat al-Raabehah — Chicago",
};

function stripHtml(html) {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

function truncate(text, max = 200) {
  if (!text) return "";
  if (text.length <= max) return text;
  return text.slice(0, max - 1).trimEnd() + "…";
}

const SEO = ({
  title,
  description,
  image,
  url,
  type = "website",
  // Supply these when the image dimensions are known. WhatsApp often drops the
  // preview image without them. Mirrors buildOgTags in api/og/index.js — keep
  // the two in step.
  imageWidth,
  imageHeight,
  imageType,
  imageAlt,
}) => {
  const finalTitle = title
    ? `${title} | ${DEFAULTS.siteName}`
    : DEFAULTS.title;
  const finalDescription = truncate(stripHtml(description) || DEFAULTS.description);
  const finalImage = image || DEFAULTS.image;
  const finalUrl =
    url ||
    (typeof window !== "undefined" ? window.location.href : "https://tr.chicagojamaat.org");

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      {finalImage.startsWith("https:") && (
        <meta property="og:image:secure_url" content={finalImage} />
      )}
      {imageType && <meta property="og:image:type" content={imageType} />}
      {imageWidth && imageHeight && (
        <meta property="og:image:width" content={String(imageWidth)} />
      )}
      {imageWidth && imageHeight && (
        <meta property="og:image:height" content={String(imageHeight)} />
      )}
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta property="og:url" content={finalUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}
    </Helmet>
  );
};

export default SEO;
